export default __webpack_public_path__ + "cc02acdb3bd06eb6d5a281474f418104.svg";